module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    staticClass: "hidden-xs-only"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeueVeranstaltung = true) && (_vm.neueVeranstaltung = {
                kalender: _vm.kalender[0]
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.calendar.prev()
            }
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Letzter Monat")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.setToday()
            }
          }
        }, on), [_vm._v(_vm._s(_vm.$filters.date(_vm.start, "MM.YYYY")))])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Aktueller Monat")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.$refs.calendar.next()
            }
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Nächster Monat")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeueVeranstaltung),
      callback: function($$v) {
        _vm.showNeueVeranstaltung = $$v
      },
      expression: "showNeueVeranstaltung"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "xl"
    }
  }, [_c('v-card-title', [_c('div', [_vm._v("Neue Veranstaltung erstellen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueVeranstaltung = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.neueVeranstaltung.titel),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "titel", $$v)
      },
      expression: "neueVeranstaltung.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.vonDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Beginn",
            "readonly": ""
          },
          model: {
            value: (_vm.formatVonDatum),
            callback: function($$v) {
              _vm.formatVonDatum = $$v
            },
            expression: "formatVonDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.changeVonDatum,
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.vonDatum),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "vonDatum", $$v)
      },
      expression: "neueVeranstaltung.vonDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.vonZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.vonZeit),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "vonZeit", $$v)
            },
            expression: "neueVeranstaltung.vonZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.neueVeranstaltung.vonZeit),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "vonZeit", $$v)
      },
      expression: "neueVeranstaltung.vonZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.bisDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Ende",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBisDatum),
            callback: function($$v) {
              _vm.formatBisDatum = $$v
            },
            expression: "formatBisDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.bisDatum),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bisDatum", $$v)
      },
      expression: "neueVeranstaltung.bisDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.bisZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.bisZeit),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "bisZeit", $$v)
            },
            expression: "neueVeranstaltung.bisZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.neueVeranstaltung.bisZeit),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bisZeit", $$v)
      },
      expression: "neueVeranstaltung.bisZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.kleiderordnungen,
      "label": "Kleiderordnung"
    },
    model: {
      value: (_vm.neueVeranstaltung.kleiderordnung),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kleiderordnung", $$v)
      },
      expression: "neueVeranstaltung.kleiderordnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.neueVeranstaltung.ort),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "ort", $$v)
      },
      expression: "neueVeranstaltung.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "messages": "o/ho",
      "label": "Kategorie"
    },
    model: {
      value: (_vm.neueVeranstaltung.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kategorie", $$v)
      },
      expression: "neueVeranstaltung.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Preis"
    },
    model: {
      value: (_vm.neueVeranstaltung.preis),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "preis", $$v)
      },
      expression: "neueVeranstaltung.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-menu', {
    ref: "neueVeranstaltung.anmeldungBis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Anmeldung bis",
            "readonly": ""
          },
          model: {
            value: (_vm.neueVeranstaltung.anmeldungBis),
            callback: function($$v) {
              _vm.$set(_vm.neueVeranstaltung, "anmeldungBis", $$v)
            },
            expression: "neueVeranstaltung.anmeldungBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu5),
      callback: function($$v) {
        _vm.menu5 = $$v
      },
      expression: "menu5"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu5 = false
      }
    },
    model: {
      value: (_vm.neueVeranstaltung.anmeldungBis),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "anmeldungBis", $$v)
      },
      expression: "neueVeranstaltung.anmeldungBis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.itemsKalender,
      "label": "Kalender"
    },
    model: {
      value: (_vm.neueVeranstaltung.kalender),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "kalender", $$v)
      },
      expression: "neueVeranstaltung.kalender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "hint": "Pflichtanmeldungen können nicht mehr bearbeitet werden!",
      "multiple": "",
      "outlined": "",
      "dele": "",
      "deletable-chips": "",
      "chips": "",
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.gruppen,
      "label": "Pflichtanmeldungen"
    },
    model: {
      value: (_vm.neueVeranstaltung.pflichtanmeldungen),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "pflichtanmeldungen", $$v)
      },
      expression: "neueVeranstaltung.pflichtanmeldungen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "5",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.neueVeranstaltung.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.neueVeranstaltung, "bemerkung", $$v)
      },
      expression: "neueVeranstaltung.bemerkung"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueVeranstaltung = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": "",
      "disabled": !(
        _vm.neueVeranstaltung.kalender &&
        !(_vm.neueVeranstaltung.titel == null || _vm.neueVeranstaltung.titel.trim() === '') &&
        !(_vm.formatVonDatum == null || _vm.formatVonDatum.trim() === '')
      )
    },
    on: {
      "click": function($event) {
        return _vm.saveVeranstaltung()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "rounded-0",
    attrs: {
      "flat": "",
      "height": 'calc(100vh - 195px)'
    }
  }, [_c('v-calendar', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        right: function () { return _vm.$refs.calendar.prev(); },
        left: function () { return _vm.$refs.calendar.next(); }
      }),
      expression: "{ right: () => $refs.calendar.prev(), left: () => $refs.calendar.next() }"
    }],
    ref: "calendar",
    attrs: {
      "color": "primary",
      "events": _vm.events,
      "short-weekdays": _vm.shortWeekdays,
      "short-months": _vm.shortMonths,
      "now": _vm.now,
      "event-more": false,
      "type": "month",
      "locale": "de-de",
      "weekdays": _vm.weekdays,
      "event-color": _vm.getEventColor,
      "event-text-color": "white"
    },
    on: {
      "click:event": _vm.showEvent
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _vm._v(" "), _c('dialogVeranstaltung', {
    attrs: {
      "visible": _vm.selectedOpen,
      "selectedEvent": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.selectedOpen = $event
      },
      "close": function($event) {
        _vm.selectedOpen = false
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eff6675"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/veranstaltungen.vue
// module id = 764
// module chunks = 15